import { resolveMediaUrl } from '../../utils/media';
import Section from '../common/Section';

const MediaSection = ({ data, onFileChange }) => {
  const profilePhotoUrl = resolveMediaUrl(data?.profilePhoto);
  const coverImageUrl = resolveMediaUrl(data?.coverImage);

  const profilePhotoLabel =
    typeof data.profilePhoto === 'string' ? data.profilePhoto : data.profilePhoto?.name || '';
  const coverImageLabel =
    typeof data.coverImage === 'string' ? data.coverImage : data.coverImage?.name || '';

  return (
    <Section eyebrow="Step 5" title="Profile media">
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Profile Photo Upload</label>
          {profilePhotoUrl && (
            <img
              src={profilePhotoUrl}
              alt="Profile"
              className="profile-photo-preview"
            />
          )}
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={(e) => onFileChange('media', 'profilePhoto', e.target.files)}
          />
          {profilePhotoLabel && <p className="small text-muted mb-0 mt-1">Selected: {profilePhotoLabel}</p>}
        </div>
        <div className="col-md-6">
          <label className="form-label">Cover Image (optional)</label>
          {coverImageUrl && (
            <img
              src={coverImageUrl}
              alt="Cover"
              className="cover-photo-preview"
            />
          )}
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={(e) => onFileChange('media', 'coverImage', e.target.files)}
          />
          {coverImageLabel && <p className="small text-muted mb-0 mt-1">Selected: {coverImageLabel}</p>}
        </div>
      </div>
    </Section>
  );
};

export default MediaSection;
